import { c as _c } from "react/compiler-runtime";
import { Hint } from '@systemeio/ui';
import ContactInfoTooltip from 'modules/contacts/components/contact-info-tooltip';
import MobileSettingsHeader from 'modules/funnels/funnel/components/mobile-settings-header';
import { FunnelStepSettingTabsEnum } from 'modules/funnels/funnel/enums/funnel-step-setting-tabs-enum';
import { useFunnelLeads } from 'modules/funnels/funnel/hooks/use-funnel-leads';
import { FunnelLeadsInterface } from 'modules/funnels/funnel/types/funnel-leads-interface';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import React from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { dateTimeFormat } from 'shared/utils/date-time-format';
interface LeadsTabProps {
  funnelId: FunnelId;
  funnelStep: FunnelStepInterface | null;
}
function LeadsTab(t0) {
  const $ = _c(53);
  const {
    funnelId
  } = t0;
  const {
    setPagination,
    pagination,
    setLimit,
    limit
  } = usePagination();
  const {
    t
  } = useLocoTranslation();
  const {
    user,
    isWsAssistant
  } = useUser();
  let t1;
  if ($[0] !== funnelId || $[1] !== limit || $[2] !== pagination) {
    t1 = {
      funnelId,
      limit,
      pagination
    };
    $[0] = funnelId;
    $[1] = limit;
    $[2] = pagination;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    leads,
    counter
  } = useFunnelLeads(t1);
  let t2;
  if ($[4] !== t) {
    t2 = t("dashboard.funnel.leads_opt_in_date");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== user?.dateFormat || $[7] !== user?.timeFormat || $[8] !== user?.timezone) {
    t3 = lead => <span>{dateTimeFormat(lead.date, {
        timeFormat: user?.timeFormat,
        dateFormat: user?.dateFormat,
        timeZone: user?.timezone
      })}</span>;
    $[6] = user?.dateFormat;
    $[7] = user?.timeFormat;
    $[8] = user?.timezone;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2 || $[11] !== t3) {
    t4 = {
      key: "createdAt",
      header: t2,
      widthPercent: 30,
      onRender: t3
    };
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t) {
    t5 = t("dashboard.funnel.leads_email");
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== isWsAssistant) {
    t6 = lead_0 => <>{!isWsAssistant && lead_0.customer ? <ContactInfoTooltip fields={lead_0.customer.fieldValues} referredByEmail={lead_0.customer?.referredBy?.email} type={lead_0.customer.type} contactId={lead_0.customer?.referredBy?.connectedUser?.id}><div className="truncate"><LinkWithoutPrefetch className="primary-link w-full" href={`/contacts/${lead_0.contact.id}`}>{lead_0.contact.email}</LinkWithoutPrefetch></div></ContactInfoTooltip> : <div className="truncate"><LinkWithoutPrefetch className="primary-link w-full" href={`/contacts/${lead_0.contact.id}`}>{lead_0.contact.email}</LinkWithoutPrefetch></div>}</>;
    $[15] = isWsAssistant;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = {
      key: "email",
      header: t5,
      widthPercent: 30,
      onRender: t6
    };
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t) {
    t8 = t("dashboard.funnel.leads_funnel_step_name");
    $[20] = t;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t8) {
    t9 = {
      key: "funnelStepName",
      header: t8,
      widthPercent: 30,
      onRender: _temp
    };
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t4 || $[25] !== t7 || $[26] !== t9) {
    t10 = [t4, t7, t9];
    $[24] = t4;
    $[25] = t7;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  const columns = t10;
  let t11;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="px-4"><MobileSettingsHeader type={FunnelStepSettingTabsEnum.leads} /></div>;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t) {
    t12 = t("dashboard.funnel.leads_title_hint");
    $[29] = t;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t) {
    t13 = t("dashboard.funnel.leads");
    $[31] = t;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t12 || $[34] !== t13) {
    t14 = <Hint label={t12}>{t13}</Hint>;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== limit || $[37] !== setLimit) {
    t15 = {
      limit,
      setLimit
    };
    $[36] = limit;
    $[37] = setLimit;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== pagination || $[40] !== setPagination) {
    t16 = {
      pagination,
      setPagination
    };
    $[39] = pagination;
    $[40] = setPagination;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {};
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== columns || $[44] !== leads || $[45] !== t15 || $[46] !== t16) {
    t18 = <Table data={leads} columns={columns} limiter={t15} paginator={t16} withBorders={true} actions={t17} />;
    $[43] = columns;
    $[44] = leads;
    $[45] = t15;
    $[46] = t16;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== counter || $[49] !== leads || $[50] !== t14 || $[51] !== t18) {
    t19 = <div className="mb-5 flex flex-col lg:px-8 ">{t11}<ListingLayout counter={counter} data={leads} title={t14} titleClassName="px-1 lg:text-lg text-base font-inter font-semibold text-text-primary" type="compact">{t18}</ListingLayout></div>;
    $[48] = counter;
    $[49] = leads;
    $[50] = t14;
    $[51] = t18;
    $[52] = t19;
  } else {
    t19 = $[52];
  }
  return t19;
}
function _temp(lead_1) {
  return <div className="truncate">{lead_1.page.funnelStep.name}</div>;
}
export default LeadsTab;